import { render, staticRenderFns } from "./HistoricalCompanyFilter.vue?vue&type=template&id=0b81fde6&scoped=true&"
import script from "./HistoricalCompanyFilter.vue?vue&type=script&lang=js&"
export * from "./HistoricalCompanyFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b81fde6",
  null
  
)

export default component.exports